import { GRADE, SECTION } from '../../apis/admissions/admissions.interfaces';
import { TStudentPrimary } from '../../apis/students/students.interfaces';
import { mockUserAction } from '../users/userAction';
import {
  mockStudentUserDetails,
  mockUserDetails,
} from '../users/userDetailsMock';

export const mockStudentPrimary: TStudentPrimary = {
  ...mockUserDetails,
  admissionDate: {
    ...mockUserAction,
    timestamp: Math.floor(new Date('2020-01-15T00:00:00.000Z').getTime() / 1000),
  },
  grade: GRADE.TEN,
  gradeId: '10',
  category: 'General',
  section: SECTION.A,
  bankDetails: {
    accountNumber: '1234567890123456',
    ifscCode: 'HDFC0001234',
    bankName: 'HDFC Bank',
    branchName: 'Connaught Place',
  },
};

export const mockStudentPrimary2: TStudentPrimary = {
  ...mockStudentUserDetails,
  admissionDate: {
    ...mockUserAction,
    timestamp: Math.floor(new Date('2021-01-15T00:00:00.000Z').getTime() / 1000),
  },
  grade: GRADE.ELEVEN,
  category: 'OBC',
  gradeId: '11',
  section: SECTION.B,
  bankDetails: {
    accountNumber: '9876543210987654',
    ifscCode: 'SBIN0005678',
    bankName: 'State Bank of India',
    branchName: 'MG Road',
  },
};
